import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AcademicYearService } from '../../../../../../core/services/academic-year.service';
import { PeriodService } from '../../../../../../core/services/period.service';
import { PersonalService } from '../../../../../../core/services/personal.service';
import { ProfessorService } from '../../../../../../core/services/professor.service';
import { RequestPermissionService } from '../../../../../../core/services/request-permission.service';
import { StudentService } from '../../../../../../core/services/student.service';
import { AppErrorShow } from '../../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule, NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../../layout/includes/header/header.component';

@Component({
    selector: 'app-request-permission-index',
    templateUrl: './request-permission-index.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule,
        NgxPaginationModule,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        NgSelectComponent,
    ],
    styleUrls: ['./request-permission-index.component.css']
})
export class RequestPermissionIndexComponent {
  buttonsPermission :any|undefined;
 search_text=""
  structures:any[] =[]
  roles:any[] =[]
  periods:any[] =[]
  data:any[] =[]
  concerned:any[] =[]
  students:any[] =[]
  professors:any[] =[]
  request_permissions:any[] =[]
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="admin-bvs-request-permissions"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  type:any


  constructor(
    private rpService:RequestPermissionService,
    private ayService:AcademicYearService,
    private personalService:PersonalService,
    private periodService:PeriodService,
    private professorService:ProfessorService,
    private studentService:StudentService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    
    this.user=this.lsService.get(GlobalName.userName)
      this.role=this.user.roles[0].name.toLowerCase()
      console.log(this.role)
    this.init()
    this.getActions()
  }

  init(){
    this.request_permissions=this.lsService.get(GlobalName.features).request_permissions
    this.getAll()
    this.getPeriods()
  }

 

  getAll(){
    this.rpService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des demandes de permission",err)
    })
  }
  loadConcerned(ev:any){
    switch(ev){
      case "Enseignant":
        this.getProfessors()
        break;
      case "Apprenant":
        this.getStudents()
        break;
      case "Personnel":
        this.getPersonals()
        break;
        default :
        this.getPersonals()
        break;
    }
  }


  getPersonals(){
    this.personalService.getAll().subscribe((res:any)=>{
      this.concerned=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des demandes de permission",err)
    })
  }
  getStudents(){
    this.studentService.getAll().subscribe((res:any)=>{
      this.concerned=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des demandes de permission",err)
    })
  }
  getProfessors(){
    this.professorService.getAll().subscribe((res:any)=>{
      this.concerned=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des demandes de permission",err)
    })
  }
  getPeriods(){
    this.periodService.getAll().subscribe((res:any)=>{
      this.periods=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des demandes de permission",err)
    })
  }


  store(value:any){
    this.loading=true
    
    this.rpService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false
        AppErrorShow.showError("Gestion des demandes de permission",err)

    })
  }
  update(value:any){
    this.loading=true
    delete value.type
    this.rpService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false
        AppErrorShow.showError("Gestion des demandes de permission",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.rpService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
        AppErrorShow.showError("Gestion des demandes de permission",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.status
    console.log(this.selected_data)
    this.type=el.type
    this.loadConcerned(el.type)
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.rpService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
          AppErrorShow.showError("Gestion des demandes de permission",err)

      })
  }
  reject(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.rpService.setState(this.selected_data.id,2,{motif:value.motif}).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
          AppErrorShow.showError("Gestion des demandes de permission",err)

      })
  }

  getPage(event:any){
    this.pg.p=event
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:true,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }
}
